
import { IconButton, Tooltip } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../context/AppContext";

export default function BackButton() {
  const navigate = useNavigate();
  const { user } = useAppContext();

  if (!user) return null;

  return (
    <Tooltip title="Back">
      <IconButton
        onClick={() => navigate(-1)}
        aria-label="Go back"
        sx={{
          color: "#FCF6F5",            
        }}
      >
        <ArrowBackIcon />
      </IconButton>
    </Tooltip>
  );
}